import {Image} from "primereact/image";
import {getImageUrl} from "../../common/utils/imageUtils";
import React from "react";
import {useTranslation} from 'react-i18next';
import {Image as ImageType} from '../../admin/artisticobjects/types/Image';
import {Button} from "primereact/button";
import {useSortable} from "@dnd-kit/sortable";
import {CSS} from '@dnd-kit/utilities';
import {getImageTypeIcon} from "../../admin/artisticobjects/types/ImageType";

interface AdminUploadedImageProps {
  image: ImageType;
  onImageDelete: (imageId: string, imageName: string, e: React.MouseEvent<HTMLButtonElement>) => void;
  onImageEdit: (imageId: string, e: React.MouseEvent<HTMLButtonElement>) => void;
}

const AdminUploadedImage: React.FC<AdminUploadedImageProps> = ({image, onImageDelete, onImageEdit}) => {
  const {t} = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({id: image.id});

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div
      ref={setNodeRef}
      key={image.id}
      style={style}
      {...attributes}
      className={`uploaded-image-card bg-black rounded shadow-sm basis-1/2 overflow-hidden relative h-64 ${isDragging ? 'opacity-90 z-10' : ''}`}
    >

      <div
        className="overflow-hidden relative flex items-center justify-center"
        {...listeners}
      >
        <Image
          src={getImageUrl(image.path)}
          alt={image.originalName}
          className="h-64"
          pt={{
            image: {
              className: 'h-64'
            }
          }}
        />

        <div
          className="absolute bottom-0 right-center bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded-sm"
        >
          <span>
            {image.imageType && (
              <i className={`fa ${getImageTypeIcon(image.imageType)} mr-2`}></i>
            )}
          </span>
          <span className="mr-2">
            {image.width} × {image.height} px
          </span>
          <small>
            ({(image.size / 1024 / 1024).toFixed(2)} MB)
          </small>

        </div>
      </div>

      <div className="absolute top-2 right-2">
        <Button
          className="bg-black bg-opacity-50 mr-1 p-1 rounded-sm text-white hover:text-gray-200"
          icon="fa fa-edit"
          severity="info"
          size="small"
          text
          onClick={(e) => onImageEdit(image.id, e)}
          aria-label={t('admin.common.actions.edit')}
        />
        <Button
          className="bg-black bg-opacity-50 p-1 rounded-sm text-white hover:text-gray-200"
          icon="fa fa-trash"
          severity="danger"
          size="small"
          text
          onClick={(e) => onImageDelete(image.id, image.originalName, e)}
          aria-label={t('admin.common.actions.delete')}
        />
      </div>
    </div>
  );
}

export default AdminUploadedImage;

